<template>
    <v-tab-item>
        <v-data-table v-bind="{ headers, items }" disable-filtering disable-pagination disable-sort hide-default-footer item-class="class" class="v-sheet--outlined" @click:row="(item) => open(item)">
            <template #[`item.class`]="{ value }">
                <v-icon v-if="!!value"> mdi-check </v-icon>
            </template>
            <template #[`item.appliedAt`]="{ value }">
                <span class="page-text--sm"> {{ value?.toDate?.() }} </span>
            </template>
            <template #[`item.recruitment`]="{ value }">
                <div class="page-text text-truncate">{{ value?.subject }}</div>
                <div class="page-text--sm grey-b3--text text-truncate">{{ value?.summary }}</div>
            </template>
            <template #[`item.resume`]="{ value }">
                <div class="page-text text-truncate">{{ value?.name }}</div>
                <div class="page-text--sm grey-b3--text text-truncate">
                    {{ [value?.personalInformation?.name, value?.personalInformation?.phone?.phoneNumberFormat?.(), value?.personalInformation?.email].join(" / ") }}
                </div>
            </template>
            <template #footer>
                <v-divider />
                <v-pagination v-model="page" :length="pageCount" :total-visible="11" color="primary" class="tab-others__pagination"></v-pagination>
            </template>
        </v-data-table>
        <component :is="ViewComponent" :value="selected" hide-others ref="view" />
    </v-tab-item>
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: Object, default: () => ({}) }, // application
    },
    data: () => ({
        applications: [],

        page: 1,
        limit: 10,
        query: {},
        summary: { totalCount: 0 },

        selected: null,

        loading: false,
    }),
    computed: {
        ViewComponent() {
            return () => import(`./application-view.vue`);
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.query;

            return {
                ...query,
                _applicant: this.value?._applicant,
            };
        },
        headers() {
            return [
                {
                    text: "",
                    value: "class",
                    width: 56,
                },
                {
                    text: "채용공고",
                    value: "recruitment",
                    cellClass: "text-truncate",
                    width: "50%",
                },
                {
                    text: "지원서",
                    value: "resume",
                    width: "50%",
                    cellClass: "text-truncate",
                },
                {
                    text: "지원일",
                    value: "appliedAt",
                    width: 110,
                },
            ];
        },
        items() {
            return [...this.applications].map((item) => ({
                ...item,
                class: item._id == this.value._id ? "current-one" : null,
            }));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
        page() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, applications } = await api.v1.company.recruitments.applications.gets({
                    _recruitment: this.value?._recruitment,
                    headers: { skip, limit },
                    params,
                });

                this.summary = summary;
                this.applications = applications;
            } finally {
                this.loading = false;
            }
        },
        open(item) {
            if (item._id == this.value._id) return;

            this.selected = item;
            this.$refs["view"].$data.shows = true;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    tbody > tr:not(.current-one) {
        cursor: pointer;
    }
    tbody > tr.current-one {
        background-color: rgba(0, 0, 0, 0.05);
    }
    tbody > tr > td.text-truncate {
        max-width: 0;
    }

    .tab-others__pagination {
        margin: 12px 0 !important;

        .v-pagination {
            margin: 0;
        }
    }
}
</style>
